export const title = 'Reestablece tu contraseña';
export const emailLabel = 'Correo';
export const codeLabel = 'Código';
export const sendCodeButton = 'Enviar código';
export const newPasswordLabel = 'Nueva contraseña';
export const updatePasswordButton = 'Actualizar Contraseña';

export const sendCodeSuccess = 'El código se ha enviado con éxito';
export const updatePasswordSuccess = '¡Tu contraseña ha sido actualizada!';
